<template src="./Semantics.html"></template>

<script>
import topMenu from '@/components/brand/components/topMenu';
import brandSelect from '@/components/components/BrandSelect';
import SearchQuery from '@/components/brand/semanticst/components/SearchQuery';
import Tags from '@/components/components/Tagst';
import {createNamespacedHelpers} from 'vuex';

const {mapGetters, mapActions} = createNamespacedHelpers('brand/semanticst')

export default {
  name: "BrandSemantics",
  components: {
    topMenu,
    SearchQuery,
    brandSelect,
    Tags
  },
  data() {
    return {
      brandId: this.$route.params.id,
      showOverlay: false,
      clipboardText: '',
      isCopyToClipboard: false,
      ruMinus: null,
      wwMinus: null,
    }
  },
  methods: {
    ...mapActions([
      'GET_SEMANTICS',
      'SAVE_RU_SEO',
      'SAVE_WW_SEO',
      'SAVE_RU_PPC',
      'SAVE_WW_PPC',
      'SAVE_RU_MINUS',
      'SAVE_WW_MINUS',
      'FREQUENCY_UPDATE',
      'GET_LANGUAGES'
    ]),
    brandsChange: function (brand) {
      if (brand == null || (this.CURRENT_BRAND != null && this.CURRENT_BRAND.id == brand.id)) {
        return
      }
      this.brandId = brand.saleId.toString()
      this.$store.commit('brand/semanticst/CURRENT_BRAND', brand);
      this.$store.commit('brand/semanticst/SALE_ID', brand.saleId);
      this.getSemantics()
    },
    saveRuSEO: function () {
      this.SAVE_RU_SEO({th: this});
    },
    saveWwSEO: function () {
      this.SAVE_WW_SEO({th: this});
    },
    saveRuPPC: function () {
      this.SAVE_RU_PPC({th: this});
    },
    saveWwPPC: function () {
      this.SAVE_WW_PPC({th: this});
    },
    saveRuMinus: function () {
      this.$store.commit('brand/semanticst/RU_MINUS', this.ruMinus);
      this.SAVE_RU_MINUS({th: this});
    },
    saveWwMinus: function () {
      this.$store.commit('brand/semanticst/WW_MINUS', this.wwMinus);
      this.SAVE_WW_MINUS({th: this});
    },
    setToClipboard: async function (textArray) {
      console.log(textArray);
      this.clipboardText = '';
      this.isCopyToClipboard = true;
      await this.$nextTick();
      for (let key in textArray) {
        let val = textArray[key];
        this.clipboardText += val + "\n";
      }
      await this.$nextTick();
      let textareaEl = this.$refs.clipboardRef.$el;
      textareaEl.select();
      textareaEl.setSelectionRange(0, 99999);
      try {
        var successful = document.execCommand('copy');
        var msg = successful ? 'successful' : 'unsuccessful';
        console.log('Testing code was copied ' + msg);
      } catch (err) {
        alert('Oops, unable to copy');
      }
      /* unselect the range */
      window.getSelection().removeAllRanges();
      this.isCopyToClipboard = false;
    },
    frequencyUpdateRuSEO: function () {
      this.FREQUENCY_UPDATE({th: this, type: 'ruSEO'});
    },
    frequencyUpdateWwSEO: function () {
      this.FREQUENCY_UPDATE({th: this, type: 'wwSEO'});
    },
    frequencyUpdateRuPPC: function () {
      this.FREQUENCY_UPDATE({th: this, type: 'ruPPC'});
    },
    frequencyUpdateWwPPC: function () {
      this.FREQUENCY_UPDATE({th: this, type: 'wwPPC'});
    },
    ruMinusChange: function () {
      console.log('ruMinusChange')
    },
    getSemantics: function () {
      if (this.IS_SEND_ALREADY != this.brandId) {
        this.GET_SEMANTICS({id: this.brandId, th: this});
      }
    },
    getLanguages: function () {
      this.GET_LANGUAGES({th: this});
    }
  },
  computed: {
    ...mapGetters([
      'RU_SEO',
      'WW_SEO',
      'RU_PPC',
      'WW_PPC',
      'RU_MINUS',
      'WW_MINUS',
      'IS_SEND_ALREADY',

      'RU_SEO_UPDATED',
      'WW_SEO_UPDATED',
      'RU_PPC_UPDATED',
      'WW_PPC_UPDATED',

      'CURRENT_BRAND',
      'LANGUAGES'
    ]),
  },
  watch: {
  },
  mounted() {
    if (this.$store.getters.getAllowSection.indexOf('brand') === -1) {
      this.$router.push({name: 'permissionDenied'});
      return;
    }
  },
  created() {
    this.$store.commit('brand/semanticst/SALE_ID', this.brandId);
    this.getSemantics()
    this.getLanguages()
  }
}
</script>

<style scoped>
.search-card {
  width: 100%;
  max-height: 370px;
  overflow-y: auto;
}

.semantics label {
  text-align: left;
  margin: 0;
  float: left;
}

.but-copy-minus {
  float: right;
  margin-bottom: 5px;
}
</style>

<style>
.semantics-container > .row {
  margin: 25px 0;
}

.row {
  margin-bottom: 2px;
}
</style>